// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f67b9126","239":"a6869b01","453":"fcfd52bf","455":"f9ba2bc8"}[chunkId] + ".chunk.js";
};